var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 2H6.75C5.49022 2 4.28204 2.50571 3.39124 3.40589C2.50044 4.30606 2 5.52696 2 6.8V45.2C2 46.473 2.50044 47.6939 3.39124 48.5941C4.28204 49.4943 5.49022 50 6.75 50H35.25C36.5098 50 37.718 49.4943 38.6088 48.5941C39.4996 47.6939 40 46.473 40 45.2V16.4L25.75 2Z",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 2V16.4H40",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 28.3999H11.5",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 38H11.5",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 18.8H13.875H11.5",
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V1H1V2H2ZM40 2H41V1H40V2ZM40 50V51H41V50H40ZM2 50H1V51H2V50ZM2 3H40V1H2V3ZM39 2V50H41V2H39ZM40 49H2V51H40V49ZM3 50V2H1V50H3Z",
    fill: "#2667FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/Contracts.6e8ebfd1db347dcad24688f3e6d81763.svg";
export { ForwardRef as ReactComponent };